import React, { Suspense, useEffect, useRef, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Card, LinearProgress, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Lottie from "lottie-react";

import SuspenseLoading from "../../common/SuspenseLoading";
import AssessmentFormHeader from "../../components/Assessments/AssessmentForm/AssessmentFormHeader";
import { createOrEditAsessment as createOrEditAsessmentAction } from "../../redux/slices/assessmentsSlice";
import AIAssessmentCard from "../../components/Assessments/AICreateAssessmentCard";
import CREATEAI from "../../assets/json/Animation.json";

const AssessmentsForm = React.lazy(() =>
  import("../../components/Assessments/AssessmentForm")
);
const AssessmentsTestSelectSection = React.lazy(() =>
  import("../../components/Assessments/AssessmentsTestSelectSection")
);

const AssessmentsCreateOrEdit = ({
  createOrEditAsessment,
  onSuccess,
  isModal,
  onClose,
}) => {
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const [loader, setLoader] = useState(false);
  const [assessment, setAssessment] = useState(state?.assessment || {});
  // const assessment = state?.assessment || {};
  console.log("assessment", assessment);
  const toEdit = state?.edit;
  const initialTests = useRef(assessment?.tests || []);

  const [initiallySelectedTests, setInitiallySelectedTests] = useState([
    ...(assessment?.tests?.length ? assessment.tests : []),
  ]);

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(validation),
    defaultValues: {
      assessment_name: "",
      role: "",
      tests: [],
      ...assessment,
    },
  });
  const { setValue, getValues, trigger, reset } = methods;
  const tests = getValues("tests");

  const [selectedTab, setSelectedTab] = useState(
    tests?.length ? tests[0]?.id : null
  );

  useEffect(() => {
    if (assessment && assessment.tests && assessment.tests.length > 0) {
      reset({
        assessment_name: assessment.assessment_name || "",
        role: assessment.role || "",
        tests: assessment.tests,
        ...assessment,
      });

      setSelectedTab(assessment.tests[0].id);

      setInitiallySelectedTests([...assessment.tests]);
    }
  }, [assessment, reset]);

  console.log("selectedTab", selectedTab);

  const handleCancelEdit = () => {
    try {
      if (isModal) {
        onClose();
      } else {
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTestAdd = (test) => {
    if (tests.length >= 4) {
      return enqueueSnackbar("You can only add up to 4 tests!", {
        variant: "warning",
      });
    }

    if (tests.find((t) => t.id === test.id)) {
      return enqueueSnackbar(`"${test.test_name}" is already added!`, {
        variant: "info",
      });
    }

    setValue("tests", [...tests, test]);
    setInitiallySelectedTests([...initiallySelectedTests, test]);

    if (!selectedTab) setSelectedTab(test.id.toString());
    trigger("tests");
  };

  // Helper function to compare arrays (to check changes in the tests array)
  const arraysEqual = (a, b) => {
    // If the length of the arrays is different, return false
    if (a.length !== b.length) return false;

    // Compare the arrays by their IDs and check for modifications in questions
    for (let i = 0; i < a.length; i++) {
      if (a[i].id !== b[i].id) return false;

      // Check if the questions inside the test are modified
      const initialTest = initiallySelectedTests.find(
        (it) => it.id === a[i].id
      );
      const currentTest = b[i];

      // If the number of questions is different, return false
      if (
        initialTest &&
        initialTest.questions.length !== currentTest.questions.length
      ) {
        return false;
      }

      // Compare each question inside the test for changes in relevant fields
      for (let q = 0; q < initialTest.questions.length; q++) {
        const initialQuestion = initialTest.questions[q];
        const currentQuestion = currentTest.questions[q];

        // Check if question fields like question_text, answer_text, or time_to_answer have changed
        if (
          initialQuestion.question_text !== currentQuestion.question_text ||
          initialQuestion.answer_text !== currentQuestion.answer_text ||
          initialQuestion.time_to_answer !== currentQuestion.time_to_answer
        ) {
          return false; // Return false if any relevant field has changed
        }

        // Check if mcqs_options has changed (if present)
        if (initialQuestion.mcqs_options && currentQuestion.mcqs_options) {
          if (
            initialQuestion.mcqs_options.length !==
            currentQuestion.mcqs_options.length
          ) {
            return false;
          }

          // Compare each option (assuming options have unique IDs or text)
          for (let o = 0; o < initialQuestion.mcqs_options.length; o++) {
            if (
              initialQuestion.mcqs_options[o] !==
              currentQuestion.mcqs_options[o]
            ) {
              return false;
            }
          }
        }
      }
    }
    return true;
  };

  const handleSubmit = async (values) => {
    try {
      // Compare initial values with current form values to detect changes
      const initialValues = {
        assessment_name: assessment?.assessment_name || "",
        tests: initialTests.current, // Use the initial reference for tests
      };

      const hasChanges =
        initialValues.assessment_name !== values.assessment_name ||
        !arraysEqual(initialValues.tests, values.tests);

      if (!hasChanges) {
        enqueueSnackbar("No changes detected", {
          variant: "info",
        });
        return; // Stop further processing
      }

      const payload = { ...values };

      payload.tests = values.tests.map((t) => {
        const test = { ...t };
        const initialTest = initiallySelectedTests.find((it) => it.id === t.id);
        let isTestEdited = test.isEdited || false;

        test.questions = t.questions
          ?.filter((q) => q.question_text.trim() && q.answer_text.trim())
          ?.map((q) => {
            const question = { ...q };
            const initialQuestion = initialTest?.questions?.find(
              (iq) => iq.id === q.id
            );

            if (q.isEdited) {
              if (
                (initialQuestion?.question_text?.toLowerCase() !==
                  q.question_text?.toLowerCase() ||
                  initialQuestion?.answer_text?.toLowerCase() !==
                    q.answer_text?.toLowerCase() ||
                  initialQuestion?.time_to_answer !== q?.time_to_answer) &&
                initialQuestion?.system
              ) {
                console.log("delete question.id");

                delete question.id;
                isTestEdited = true;
              }
              // yh key delete nh hogi ab  jahan jahan delete horhi udher se yh line remove hogi
            }

            if (q.isEdited && q?.isAi) {
              delete question.id;
              isTestEdited = true;
            }

            return question;
          });

        if (test.questions?.length !== initialTest?.questions?.length) {
          isTestEdited = true;
        }

        if (isTestEdited && test.system) {
          delete test.id;
        }
        return test;
      });

      if (payload.id && payload.system) {
        delete payload.id;
      }

      console.log("payload to send to create or edit assessment api", payload);

      await createOrEditAsessment({
        data: payload,
        cb: (response) => {
          if (typeof onSuccess === "function") return onSuccess(response);
          navigate(-1);
        },
      });
    } catch (e) {
      enqueueSnackbar(e?.message || "Something went wrong while submitting", {
        variant: "error",
      });
    }
  };

  const containerStyles = pathname.includes("/posts")
    ? { height: "100%", borderRadius: "10px" }
    : {
        m: 2,
        height: "92%",
        borderRadius: "10px",
      };

  return (
    <FormProvider {...methods}>
      <Card sx={containerStyles}>
        <AssessmentFormHeader
          onSubmit={handleSubmit}
          onCancel={handleCancelEdit}
          edit={toEdit}
        />

        {!toEdit && (
          <AIAssessmentCard
            setLoader={setLoader}
            loader={loader}
            setAssessment={setAssessment}
          />
        )}

        <Box display="flex" height={!toEdit ? "70%" : "88%"}>
          {loader ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "80%",
                height: loader ? "100%" : "80%",
                backgroundColor: "white",
                padding: "2rem",
              }}
            >
              {/* Lottie Animation */}
              <Lottie
                animationData={CREATEAI}
                style={{
                  width: "150px",
                  height: "150px",
                  marginBottom: "2rem",
                }}
                loop={true}
                autoplay={true}
              />

              {/* Main Title */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  background: "linear-gradient(45deg, #8B5CF6, #06B6D4)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textAlign: "center",
                  marginBottom: "1rem",
                  fontFamily: "Outfit",
                  fontSize: { xs: "1rem", md: "2rem" },
                }}
              >
                Creating your AI assessment
              </Typography>

              {/* Progress Bar */}
              <Box
                sx={{ width: "400px", maxWidth: "90%", marginBottom: "1rem" }}
              >
                <LinearProgress
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#E5E7EB",
                    "& .MuiLinearProgress-bar": {
                      background: "linear-gradient(90deg, #8B5CF6, #06B6D4)",
                      borderRadius: 4,
                    },
                  }}
                />
              </Box>

              {/* Subtitle */}
              <Typography
                variant="body1"
                sx={{
                  color: "#929BAE",
                  textAlign: "center",
                  fontSize: "1rem",
                  fontFamily: "Outfit",
                }}
              >
                Generating role-specific questions...
              </Typography>
            </Box>
          ) : (
            <Suspense fallback={<SuspenseLoading width="80%" height="80%" />}>
              <AssessmentsForm
                selectedTab={selectedTab}
                onSelectedTabChange={setSelectedTab}
              />
            </Suspense>
          )}
          {/* </Box> */}

          <Suspense fallback={<SuspenseLoading width="20%" height="80%" />}>
            <AssessmentsTestSelectSection onTestAdd={handleTestAdd} />
          </Suspense>
        </Box>
      </Card>
    </FormProvider>
  );
};

const validation = Yup.object().shape({
  assessment_name: Yup.string().required("Assessment name is required!"),
  role: Yup.string().required("Role is required!"), // Added validation for role
  tests: Yup.array()
    .of(
      Yup.object().shape({
        questions: Yup.array()
          .of(
            Yup.object().shape({
              question_text: Yup.string()
                .required("Question text cannot be empty!")
                .nullable()
                .test(
                  "not-null",
                  "Question text cannot be null!",
                  (value) => value !== null
                ),
              answer_text: Yup.string()
                .required("Answer text cannot be empty!")
                .nullable()
                .test(
                  "not-null",
                  "Answer text cannot be null!",
                  (value) => value !== null
                ),
              time_to_answer: Yup.string().nullable(),
            })
          )
          .min(1, "Add at least one question!")
          .required("Add at least one question!"),
      })
    )
    .min(1, "Select at least one test!")
    .required("Select at least one test!")
    .test(
      "validate-tests",
      "First test must contain at least one valid question with both text and answer!",
      (tests) => {
        if (!tests || tests.length === 0) return false;
        const firstTest = tests[0];
        return firstTest?.questions.some(
          (q) => q.question_text?.trim() && q.answer_text?.trim()
        );
      }
    ),
});

const mapDispatchToProps = {
  createOrEditAsessment: createOrEditAsessmentAction,
};

export default connect(null, mapDispatchToProps)(AssessmentsCreateOrEdit);
